<div
  id="bomb-prices-envoltura"
  class="container-fluid bomb-prices-container">
  <div
    id="bomb-prices-container"
    class="container">
    <div
      id="bomb-prices-title"
      class="row m-1 mt-0">
      <div class="col-lg-10 col-md-9 col-sm-9 col-8 d-flex align-items-center">
        <cgw-section-title [text]="title"></cgw-section-title>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-3 col-4">
        <div class="arrows d-flex justify-content-end">
          @if (!carousel()?.instance?.()?.isLocked) {
            <cgw-carousel-arrows
              (onPrevious)="carousel().previousSlide()"
              (onNext)="carousel().nextSlide()">
            </cgw-carousel-arrows>
          }
        </div>
      </div>
    </div>
    <ng-template
      #bombPricesProductsTemplate
      let-item="item">
      <cgw-product-card
        [product]="item"
        [size]="'medium'"
        [vertical]="true">
      </cgw-product-card>
    </ng-template>
    <div class="row">
      <div class="cards">
        @if (bombPricesPreview()) {
          <cgw-preview-card
            class="cards__preview"
            [previewCard]="bombPricesPreview()">
          </cgw-preview-card>
        }
        <div id="brands">
          <cgw-carousel-base
            [config]="carouselConfig()"
            [items]="carouselItems()">
          </cgw-carousel-base>
        </div>
      </div>
    </div>
  </div>
</div>
